<template>
  <div class="vw100 vh100 flex-box flex-col al-c ju-c">
    <div class="w100">
      <div class="w120 mc flex-box al-c">
        <div class="flex-1">
          <img :src="`${baseUrl}images/logo1.png`">
        </div>
        <!-- <el-button type="primary" plain round size="medium" @click="goHref()">游客登录</el-button> -->
      </div>
    </div>
    <div class="w100 mt10 login-wrapper flex-box ju-c" :style="{ 'background-image': `url(${baseUrl}images/login-bg.png)` }">
      <div class="flex-box al-c login-main" :style="{ 'background-image': `url(${baseUrl}images/login-main-bg.png)` }">
        <div class="flex-1 pl20 pr20 ml20">
          <img :src="`${baseUrl}images/login-title.png`">
        </div>
        <div class="login-view">
          <p class="font-20 pb10 tx-c" style="color: #0175e2">一站式服务平台</p>
          <div class="w100 mt20 pl5 pr5">
            <el-input size="medium" v-model="uesrName" @keyup.enter.native="logining" placeholder="用户名"></el-input>
          </div>
          <div class="w100 mt20 pl5 pr5">
            <el-input type="password" size="medium" v-model="password" @keyup.enter.native="logining" clearable show-password placeholder="密码"></el-input>
          </div>
          <div class="w100 mt20 pl5 pr5 flex-box">
            <div class="flex-1">
              <el-checkbox v-model="remember">记住我</el-checkbox>
            </div>
            <!-- <router-link class="blue cu-p" :to="'/forgetPassword'">忘记密码？</router-link> -->
          </div>
          <div class="w100 mt20 pb20 pl5 pr5">
            <el-button class="w100" size="medium" type="primary" :disabled="uesrName == '' || password == ''" :loading="loading" @click="logining">登 录</el-button>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="w100 mt20 tx-c grey font-14">南宁市迈越软件有限责任公司 © 版权所有 辽ICP备12008717号</div>-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Login",
  props: [],
  components: {},
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      uesrName: "",
      password: "",
      remember: false
    };
  },
  computed: {
    ...mapGetters(["userToken"])
  },
  created() {
    // window.sessionStorage.setItem("userToken", "123123");
    if (this.userToken) {
      this.logout();
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    ...mapActions(["setUserToken", "setUserData", "logout"]),
    logining() {
      if (!this.uesrName || !this.password) {
        return;
      }
      this.loading = true;
      // window.sessionStorage.setItem("userToken", "");
      // window.location = "./";
      
      // this.loading = false;
      this.loading = true;
      this.$http
        .post("/web/login",
          this.$qs.stringify({
            username: this.uesrName,
            password: this.password
          })
        )
        .then(res => {
          if (res.data.resCode === 0) {
            window.sessionStorage.setItem("userToken", res.data.resData.sid);
            this.setUserToken(res.data.resData.sid);
            this.$nextTick(() => {
              window.location = "./";
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
.login-wrapper {
  height: 680px;
  background: #368ae2 center bottom no-repeat;
}

.login-main {
  margin-top: 60px;
  width: 900px;
  height: 430px;
  background: #fff right bottom no-repeat;
  box-shadow: 0 0 12px 10px #327cca;
}

.login-view {
  margin-right: 40px;
  width: 350px;
  padding: 20px 0 0 40px;
  border-left: 1px solid #ddd;
}
</style>
